(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-auto-carousel"] && !Shopify.designMode) return;
  try {
    
  class HwAutoCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.hw-auto-carousel__slide'));
      this.dots = Array.from(this.querySelectorAll('.hw-auto-carousel__dot'));
      this.index = 0;
      this.interval = Number(this.dataset.interval || 6000);
      this.autoplay = this.dataset.autoplay === 'true';

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(Number(dot.dataset.slideIndex || 0));
          this.restart();
        });
      });

      if (this.autoplay && this.slides.length > 1) this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
    }

    restart() {
      if (this.autoplay && this.slides.length > 1) this.start();
    }

    next() {
      this.goTo((this.index + 1) % this.slides.length);
    }

    goTo(nextIndex) {
      this.slides[this.index]?.classList.remove('is-active');
      this.slides[this.index]?.setAttribute('aria-hidden', 'true');
      this.dots[this.index]?.classList.remove('is-active');
      this.dots[this.index]?.setAttribute('aria-current', 'false');

      this.index = nextIndex;

      this.slides[this.index]?.classList.add('is-active');
      this.slides[this.index]?.setAttribute('aria-hidden', 'false');
      this.dots[this.index]?.classList.add('is-active');
      this.dots[this.index]?.setAttribute('aria-current', 'true');
    }
  }

  if (!customElements.get('hw-auto-carousel')) {
    customElements.define('hw-auto-carousel', HwAutoCarousel);
  }

  document.querySelectorAll('[data-hw-auto-carousel]').forEach((carousel) => {
    if (carousel.tagName.toLowerCase() !== 'hw-auto-carousel') {
      const upgraded = document.createElement('hw-auto-carousel');
      Array.from(carousel.attributes).forEach((attribute) => upgraded.setAttribute(attribute.name, attribute.value));
      upgraded.innerHTML = carousel.innerHTML;
      carousel.replaceWith(upgraded);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
